import { render, staticRenderFns } from "./InternetIcon.vue?vue&type=template&id=22d0849a&"
import script from "./InternetIcon.vue?vue&type=script&lang=js&"
export * from "./InternetIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports